import React from "react";
import { useMediaQuery } from "react-responsive";
import { Formik } from "formik";
import mtpImg from "../../images/mtp.svg";
import newsImg from "../../images/news.svg";
import userImg from "../../images/user.svg";
import askQuestionBigImg from "../../images/ask-question-big-simple.svg";
import { toQueryParams } from "../../utils/queryParams";

import "./scss/index.scss";
import ReactSVG from "src/components/ReactSVG";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  useDisclosure,
  Box,
  Flex,
  useToast,
  Image,
  forwardRef,
  BoxProps, Link,
} from "@chakra-ui/react";
import { baseUrl, blogUrl } from "@core/paths";
import { ChevronLeftIcon, CloseIcon } from "@chakra-ui/icons";
import logoVerticalImg from "@images/logo-mini-vertical.svg";
import { CategoriesMenu } from "../../components/MainMenu/categoriesMenu";
import { WindowSize } from "../../enums/windowSize";

const QuestionForm: React.FC<{
  modal: boolean;
  onClose?: any;
  isMobile: boolean;
}> = ({ modal, onClose, isMobile }) => {
  const toast = useToast();
  const isBigScreen = useMediaQuery({ query: "(min-width: 768px)" });
  const initialValues = {
    comment: "",
    author: "",
    email: "noreply@rogerpublishing.pl",
    comment_post_ID: "12762",
    type: "sensitive_question",
    legalTerms: false,
  };
  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values, { setStatus, resetForm, setSubmitting }) => {
        fetch("https://wp.mamaginekolog.pl/wp-comments-post.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
          body: toQueryParams(values),
        }).then(({ status }) => {
          if (status === 200) {
            toast({
              title: 'Dodano poprawnie',
              description: "Twój komentarz znajduje się aktualnie w moderacji",
              status: 'success',
              duration: 9000,
              isClosable: true,
            });
            onClose();
            resetForm({});
          } else {
            toast({
              title: 'Wystąpił błąd',
              description: "Spróbuj ponownie",
              status: 'error',
              duration: 9000,
              isClosable: true,
            });
          }
        });
      }}
    >
      {({
        handleChange,
        handleSubmit,
        handleBlur,
        values,
        status,
        setFieldValue,
        setFieldTouched,
        isSubmitting,
        isValid,
      }) => (
        <form className="px-2.5 py-5 container mx-auto" onSubmit={handleSubmit}>
          <div
            className={`flex h-16 mb-5 ${
              modal ? "items-center space-x-6" : "items-stretch space-x-4"
            }`}
          >
            {!modal && <ReactSVG path={newsImg} />}
            <ReactSVG path={mtpImg} className={modal && "h-16"} />
            {modal && !isMobile && (
              <h2 className="font-black text-xl text-blue-10">
                Zadaj swoje “Trudne pytanie”
              </h2>
            )}
          </div>
          <div className="bg-advice-pattern pt-4 px-3 pb-3 mb-8">
            <div className={`bg-white mb-2`}>
              <div className={`font-black text-s mb-3 py-6 ${modal ? "px-8" : "px-2.5"}`}>
                <span className="text-blue-10">DROGA </span>
                <span className="text-pink-2">REDAKCJO:</span>
              </div>
              <textarea
                className={isMobile
                  ? `placeholder-grey-17 font-normal ${modal ? "px-8" : "px-2.5"}`
                  : `border-0 focus:ring-0 resize-none p-0 placeholder-grey-17 text-xs font-normal ${modal ? "px-8" : "px-2.5"}`
                }
                value={values.comment}
                name="comment"
                onChange={handleChange}
                onBlur={handleBlur}
                rows={modal || isBigScreen ? 10 : 4}
                style={{ width: '100%', outline: 0 }}
                placeholder="Miejsce na Twoją wiadomość..."
                required
              />
            </div>
            <div
              className={`bg-white flex space-x-4 ${
                modal ? "px-8 py-6" : "p-2.5"
              }`}
            >
              <ReactSVG path={userImg} />
              <input
                className={isMobile ? "placeholder-grey-17 font-normal outline-none" :"flex-grow outline-none p-0 placeholder-grey-17 text-xs font-normal"}
                value={values.author}
                onChange={handleChange}
                placeholder="Imię lub pseudonim"
                name="author"
                required
              />
            </div>
          </div>
          <div className="px-2.5 text-xs text-grey-18 font-normal">
            <div className="mb-3">
              <label htmlFor="legalTerms" className="flex space-x-3">
                <input
                  className={isMobile ? "mr-3 focus:ring-0 text-grey-18 h-5 w-5 cursor-pointer" : "mr-3 rounded-sm cursor-pointer h-5 w-5 border-grey-19 focus:ring-0 text-grey-18"}
                  type="checkbox"
                  id="legalTerms"
                  name="legalTerms"
                  checked={values.legalTerms}
                  onChange={handleChange}
                  required
                  onBlur={handleBlur}
                />
                <Box>
                  Oświadczam, że zapoznałam/em się z
                  <Link outline="none" m="0 4px" href={`${window.location.origin}/regulamin-bloga`} target="_blank">Regulaminem Bloga</Link>  i
                  <Link outline="none" m="0 4px" href={`${window.location.origin}/polityka-prywatnosci-bloga`} target="_blank">Polityką Prywatności</Link>
                  oraz akceptuję ich treść.
                </Box>

              </label>
            </div>
            <div className="px-2.5 text-xs text-grey-18 font-normal">
              Redakcja wraz z ekspertami odpowiada na WYBRANE pytania, których problematyka dotyczy dużej liczby czytelników.
            </div>
          </div>
          <Flex mb={isMobile ? "90px" : 0} mt="2rem" className="flex justify-between items-center">
            <button
              type="submit"
              className={isMobile ? 'w-full' : `w-full mt-4 ${modal ? "max-w-xs" : "max-w-sm"}`}
            >
              <ReactSVG className="w-full" path={askQuestionBigImg} />
            </button>
            {modal && !isMobile && (
              <Button
                variant="ghost"
                onClick={onClose}
                className="font-museo-moderno text-base font-medium text-black"
              >
                Anuluj
              </Button>
            )}
          </Flex>
        </form>
      )}
    </Formik>
  );
};

const AskQuestionModal: React.FC<{
  isOpen: any;
  onClose: any;
  isMobile: boolean;
}> = ({ isOpen, onClose, isMobile }) => {
  return (
    <Modal size={isMobile ? 'full' : 'xl'} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton d={{base: 'none', md: 'block'}} w="48px" h="48px" bg="#E147C9" borderRadius="40px" color="#fff" fontSize="18px" mt="-30px" />
        <ModalBody d={{base: 'none', md: 'block'}}>
          <QuestionForm isMobile={false} modal={true} onClose={onClose} />
        </ModalBody>
        <ModalBody p="0" d={{base: 'block', md: 'none'}}>
            <Flex p="10px" borderBottom="0.4px solid #80A0C7" justifyContent="space-betweeen">
              <Flex gridGap="15px" w="100%" gridArea="search" alignItems="center" justifyContent="flex-start">
                <ChevronLeftIcon cursor="pointer" fontSize="1em" onClick={onClose}/>
                <Image onClick={onClose} src={logoVerticalImg} w="50px" alt="" />
              </Flex>
              <Flex background="#EAF4FF"
                    w="33px"
                    h="33px"
                    justifyContent="center"
                    alignItems="center"
                    borderRadius="50%"
                    onClick={onClose}
              >
                <CloseIcon w="18px" fontSize="10px" />
              </Flex>
            </Flex>
            <Flex p="10px">
              <QuestionForm isMobile={true} modal={true} onClose={onClose} />
            </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
//   return (
//     <ModalRoutingContext.Consumer>
//       {({ modal, closeTo }) =>
//         modal ? (
//           <div className="p-5">
//             {/*          <button>
//             <ReactSVG
//               className="right-3 top-3 h-12"
//               path={closeImg}
//             />
//           </button> */}
//             <QuestionForm modal={modal} closeTo={closeTo} />
//           </div>
//         ) : (
//           <Layout
//             metaTitle="Trudne pytania - zadaj pytanie"
//             categories={categories}
//             tags={tags}
//           >
//             <div className="max-w-xl mx-auto">
//               <QuestionForm modal={modal} />
//             </div>
//           </Layout>
//         )
//       }
//     </ModalRoutingContext.Consumer>
//   );
// };
}

const AskQuestion = forwardRef<BoxProps, "div">(
  (props, ref) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { isOpen: isOpenMobile, onOpen: onOpenMobile, onClose: onCloseMobile } = useDisclosure()

  return (
    <Box {...props}>
      <Box d={{base: 'none', md: 'block'}} pb="30px" as={ReactSVG} path={askQuestionBigImg} className="cursor-pointer" onClick={onOpen} />
      <Box d={{base: 'block', md: 'none'}} pb="30px" as={ReactSVG} path={askQuestionBigImg} className="cursor-pointer" onClick={onOpenMobile} />
      <AskQuestionModal isMobile={false} isOpen={isOpen} onClose={onClose} />
      <AskQuestionModal isMobile={true} isOpen={isOpenMobile} onClose={onCloseMobile} />
    </Box>
  )
});

export default AskQuestion;
